<script>
	import { onMount } from "svelte";
	let language;
	import { nav } from "./store.js";
	let navi = nav;
	let widthEnough =  (window.screen.width > 800);

	onMount(() => {
		// Run the code

		/* 
		let lanclick = true;
		let lancur = language.querySelector(".current");
		let lanval = lancur.innerText;
		lancur.addEventListener("click", () => {
			if (lanclick) {
				lancur.innerText = lanval + " X ";
				language.querySelector("div").style.transform = "translate(-100%, 2px)";
				language.querySelector("div").style.opacity = 1;
				language.querySelector("div").style.display = "block";
				language.querySelector("div").style.zIndex = 50;

				lanclick = false;
			}
			else {
				lancur.innerText = lanval ;
				language.querySelector("div").style.opacity = 0;
				language.querySelector("div").style.transform = "translate(-100%, -10%);";
				language.querySelector("div").style.zIndex = 1;
				setTimeout(() => {
					language.querySelector("div").style.display = "none";
				}, 300);
				lanclick = true;
			}
		})
		*/

	});

	function wipe(navfunc, link_to) {
		
		if (link_to != $navi) {
			const wipeout = document.querySelector(".wipeout");
			wipeout.style.visibility = "visible";
			wipeout.style.transform = "translateX(-102%)";
			setTimeout(navfunc, 1000);
		}
	}
</script>

<header>
	<div class="logo">
		<img src="./logo.png" alt="Logo" />
		<a href="/"><h1>Some Token</h1></a>
	</div>

	<!-- svelte-ignore component-name-lowercase -->
	{#if widthEnough}
	<nav>
		<ul>
			<li>
				<a
					href="/"
					on:click={(e) => {
						e.preventDefault();
						wipe(() => navi.set("home"), "home");
					}}>Home</a
				>
			</li>
			<li>
				<a
					href="/"
					on:click={(e) => {
						e.preventDefault();
						wipe(() => navi.set("about"), "about");
					}}>About</a
				>
			</li>
			<li>
				<a
					href="/"
					on:click={(e) => {
						e.preventDefault();
						wipe(() => navi.set("market"), "market");
					}}>Market Data</a
				>
			</li>
		</ul>
	</nav>
	<div bind:this={language} class="language"> 

		<h3 class="current">English</h3>
		
		<!--
			<div>
				<a href="/">Turkish</a>	
			</div>
		-->
	</div> 
	{:else}
	<div bind:this={language} class="language"> 

		<h3 class="current">English</h3>
		<!--
			<div>
				<a href="/">Turkish</a>	
			</div>
		-->
	</div> 

	<nav>
		<ul>
			<li>
				<a
					href="/"
					on:click={(e) => {
						e.preventDefault();
						wipe(() => navi.set("home"), "home");
					}}>Home</a
				>
			</li>
			<li>
				<a
					href="/"
					on:click={(e) => {
						e.preventDefault();
						wipe(() => navi.set("about"), "about");
					}}>About</a
				>
			</li>
			<li>
				<a
					href="/"
					on:click={(e) => {
						e.preventDefault();
						wipe(() => navi.set("market"), "market");
					}}>Market Data</a
				>
			</li>
		</ul>
	</nav>
	
	{/if}
	

</header>

<style>
	@keyframes navboxanim {
		0% {
			border: 2px solid #eeeeee00;
			border-bottom: 2px solid #eee;
		}
		25% {
			border: 2px solid #eeeeee00;
			border-bottom: 2px solid #eee;
			border-right: 2px solid #eee;
		}
		50% {
			border: 2px solid #eeeeee00;
			border-right: 2px solid #eee;
			border-top: 2px solid #eee;
		}
		75% {
			border: 2px solid #eeeeee00;
			border-top: 2px solid #eee;
			border-left: 2px solid #eee;
		}
		100% {
			border: 2px solid #eeeeee00;
			border-left: 2px solid #eee;
			border-bottom: 2px solid #eee;
		}
	}

	header {
		position: absolute;
		top: 0px;
		left: 0px;
		z-index: 40;
		width: 100vw;
		padding: 0.5rem 3rem;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	.logo {
		display: flex;
		align-items: center;
		justify-content: flex-start;
	}
	.logo img {
		height: 2.5rem;
		width: auto;
	}
	.logo a {
		color: white;
		text-decoration: none;
	}
	.logo h1 {
		font-size: 1.4rem;
		white-space: nowrap;
		margin: 0;
	}

	nav ul {
		list-style: none;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}
	nav ul li a {
		margin: 0 0.8rem;
		font-size: 1rem;
		display: block;
		box-sizing: content-box;
		white-space: nowrap;
		color: #eee;
		border-radius: 50vh;
		padding: 0.4rem 0.8rem;
		transition: all 0.8s ease;
		border: 2px solid rgba(0, 0, 0, 0);
	}
	nav ul li a:hover,
	nav ul li a:focus {
		outline: none;
		text-decoration: none;
		color: #ff7a22;
		animation-name: navboxanim;
		animation-duration: 0.2s;
		animation-iteration-count: 3;
		border: 2px solid #eee;
	}
	.language {
		height: 2rem;
		min-width: 7rem;
		width: auto;
		border-radius: 50vh;
		border: 2px solid white;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		transition: all 0.3s ease;
		cursor: pointer;
	}
	h3.current{
		margin: 0.1rem 0.4rem;
		font-size: 1rem;
	}
	/*
	.language:hover {
		background: white;
		color: #ff7a22
	}

	.language div {
		border-radius: 10px;
		position: absolute;
		top: 100%;
		left: 100%;
		transform: translate(-100%, -10%);
		opacity: 0;
		transition: all 0.3s ease;
		padding: 1rem 2rem;
		width: auto;
		min-height: 20vh;
		background: rgba(0, 0, 0, 1);
		z-index: 1;
		display: none;
	}
	.language div a{
		color: white;
		text-decoration: none;
		transition: all 0.3s ease;
	}
	.language div a:hover{
		text-decoration: underline;
	}
	*/


	/* mobile */
	@media only screen and (max-width: 800px) {
		header {
			position: absolute;
			top: 0px;
			left: 0px;
			z-index: 40;
			width: 100vw;
			/* changed */
			padding: 1rem;
			display: flex;
			align-items: center;
			justify-content: space-between;
			/* changed */
			flex-wrap: wrap;
		}
		.logo {
			display: flex;
			align-items: center;
			justify-content: flex-start;
		}
		.logo img {
			/* changed */
			height: 1.5rem;
			width: auto;
		}
		.logo h1 {
			/* changed */
			font-size: 1rem;
			margin: 0;
		}
		/* changed */
		nav{
			width: 100%;
		}
		nav ul {
			/* changed */
			padding: 0;
			

			list-style: none;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}
		nav ul li a {
			margin: 0 0.8rem;
			/* changed */
			font-size: 0.8rem;
			display: block;
			box-sizing: content-box;
			color: #eee;
			border-radius: 50vh;
			padding: 0.4rem 0.8rem;
			transition: all 0.8s ease;
			border: 2px solid rgba(0, 0, 0, 0);
		}
		nav ul li a:hover,
		nav ul li a:focus {
			outline: none;
			text-decoration: none;
			color: #ff7a22;
			animation-name: navboxanim;
			animation-duration: 0.2s;
			animation-iteration-count: 3;
			border: 2px solid #eee;
		}
		.language {
			height: 2rem;
			min-width: 7rem;
			width: auto;
			border-radius: 50vh;
			border: 2px solid white;
		}
	}
</style>
